import { createBrowserRouter, Navigate } from 'react-router-dom';
import Home from '@/pages/home/Home.jsx';
import Texture from '@/pages/texture/Texture.jsx';
import TextureUnity from '@/pages/textureUnity/TextureUnity.jsx';

import Preview from '@/pages/preview/Preview.jsx';
import Project from '@/pages/project/Project.jsx';
import Setting from '@/pages/setting/Setting.jsx';
import Tutorial from '@/pages/tutorial/Tutorial.jsx';
import TutorialDetail from '@/pages/tutorial/tutorialDetail/TutorialDetail.jsx';

import Login from '@/pages/login/index.jsx';
import DashBoardLayout from '@/components/layouts/dashboard/Dashboard.jsx';
import AccountLayout from '@/components/layouts/account/index.jsx';
import { RequireAuth } from '@/utils/auth.jsx';
import PricingPage from '@/pages/pricingPage/PricingPage';

const businessRoutes = [
  {
    path: '',
    element: <DashBoardLayout />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'texture/:projectId',
        element: <Texture />,
      },
      {
        path: 'textureUnity',
        element: <TextureUnity />,
      },
      {
        path: 'preview/:projectId',
        element: <Preview />,
      },
      {
        path: 'project',
        element: <Project />,
      },
      {
        path: 'setting',
        element: <Setting />,
      },
      {
        path: 'tutorial',
        element: <Tutorial />,
      },
      {
        path: 'tutorialDetail/:id',
        element: <TutorialDetail />,
      },
    ],
  },

  {
    path: '',
    element: <AccountLayout />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
    ],
  },
];

const routes = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/home" replace />,
  },
  {
    path: '',
    element: <RequireAuth />,
    children: businessRoutes,
  },
  {
    path: ':lang',
    element: <RequireAuth />,
    children: businessRoutes,
  },
]);

export default routes;
